import { render } from "./TotalAnualCobrancaView.vue?vue&type=template&id=7f52a76d&scoped=true"
import script from "./TotalAnualCobrancaView.vue?vue&type=script&lang=js"
export * from "./TotalAnualCobrancaView.vue?vue&type=script&lang=js"

import "./TotalAnualCobrancaView.vue?vue&type=style&index=0&id=7f52a76d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f52a76d"]])

export default __exports__